var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElementor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1C13F1EA-3705-47C9-98A9-3D99019E2CDE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landingpage",
    transform: "translate(-743.000000, -5186.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(0.000000, 4798.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plugins-Copy",
    transform: "translate(273.000000, 325.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy-27",
    transform: "translate(427.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elementor-logo",
    transform: "translate(43.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.9993478,0 L4.99956522,0 C2.23195652,0 0,2.23217391 0,5 L0,94.9995652 C0,97.7673913 2.23195652,99.9995652 4.99956522,99.9995652 L94.9993478,99.9995652 C97.7671739,99.9995652 99.9991304,97.7673913 99.9991304,94.9995652 L99.9991304,5 C99.9991304,2.23217391 97.7671739,0 94.9993478,0",
    id: "Path",
    fill: "#D63362"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 27.7904348,
    y: 27.7904348,
    width: 8.88369565,
    height: 44.4193478
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 45.5578261,
    y: 63.3258696,
    width: 26.673913,
    height: 8.88391304
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 45.5578261,
    y: 45.5578261,
    width: 26.673913,
    height: 8.88369565
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 45.5578261,
    y: 27.7680435,
    width: 26.673913,
    height: 8.88369565
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementor);
export default __webpack_public_path__ + "static/media/elementor.371ad3135ece12d1e029d9fe68de3f1e.svg";
export { ForwardRef as ReactComponent };